'use strict';
const React = require('react');
const PricingTypeCustomTable = require('./' + process.env.PRICING_TYPE + '/table');
const TableItemsComponent = require('./table-items');
class PurchaseOrderTable extends PricingTypeCustomTable {
	renderHeader() {
		if (typeof this.renderCustomHeader == 'function') {
			return this.renderCustomHeader(this.props.enableReviewAndRating);
		}
		return (
			<thead>
                <tr>
                    <th className="text-left">Descripción</th>
                    {this.props.enableReviewAndRating === true ? <th>Review</th> : <th>&nbsp;</th>}
                    <th>Cantidad</th>
                    <th width="171px">Precio unitario</th>
                    <th width="171px">Total</th>
                </tr>
            </thead>
		);
	}

	renderTableItems() {
		if (typeof this.renderCustomTableItems == 'function') {
			return this.renderCustomTableItems(this.props);
		}

		return (<TableItemsComponent {...this.props} enableReviewAndRating={this.props.enableReviewAndRating} />);
	}

	render() {
		return (
			<section className="sassy-box no-border box-order-items" hidden>
				<div className="sassy-box-content box-order-detail-invoices">
					<div className="row">
						<div id="detailOrderTotalTable" className="" style={{ maxHeight: '420'}}>
							<table id="orderdataTable" className="table order-data table-items tb-left">
								{this.renderHeader()}
								<tbody>{this.renderTableItems()}</tbody>
							</table>
						</div>
					</div>
				</div>
               
            </section>
		);
	}
}

module.exports = PurchaseOrderTable;